import { createSlice } from "@reduxjs/toolkit";
import  prescriptionList from "../../../rtk-apis/patients/patientPrescriptionList";
import preappointmentSlice from "./preappointmentSlice";

const initialState = {
  status:"",
  result:{},
  msg:"",
  loading:false,
  error:""

};

const prescriptionListSlice = createSlice({
  name: "prescriptionListSlice",
  initialState,
  reducers: {
    closeModal (state:any) { state.status = "",state.result=null; }
  },
  extraReducers: (builder) => {
    console.log("----------",builder)
    builder
      .addCase(prescriptionList.pending, (state, action) => {
        console.log("Pending")
        state.loading = true;
      })
      .addCase(prescriptionList.fulfilled, (state, { payload }) => {
        console.log("Fulfilled",payload)
        state.loading = false;
        state.status = payload.status;
        state.result = payload.result;
        state.msg = payload.msg;
      })
      .addCase(prescriptionList.rejected, (state, { payload }) => {
        console.log("Rejected")
        state.result = payload;
        state.loading = false;
      });
  },
});

export default prescriptionListSlice.reducer;
export const { closeModal } = prescriptionListSlice.actions;
